import { GENERAL_EVENTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);
@Component({
  name: "TooltipToggleButton"
})
export default class TooltipToggleButton extends Vue {
  @Prop({ default: "" })
  private hintText!: string;
  @Prop({ default: false })
  private disabled!: boolean;
  @Prop({ default: STYLE_CLASSES.TERTIARY_ROUND_BTN })
  private btnClass!: string;
  @Prop({ default: undefined })
  private btnColor!: string;
  @Prop({ default: undefined })
  private iconColor!: string;
  @Prop({ default: false })
  private xsmall!: boolean;
  @Prop({ default: false })
  private state!: boolean;

  click() {
    this.$emit(GENERAL_EVENTS.CLICK, !this.state);
  }
}
